import { render, staticRenderFns } from "./show-large-tile.vue?vue&type=template&id=3528c1e7&scoped=true"
import script from "./show-large-tile.vue?vue&type=script&setup=true&lang=js"
export * from "./show-large-tile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./show-large-tile.vue?vue&type=style&index=0&id=3528c1e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528c1e7",
  null
  
)

export default component.exports